module.exports = __webpack_public_path__ + "static/img/main_bg.79b80a19.jpg";